// extracted by mini-css-extract-plugin
export default {"zoomModal":"k3-z"};